import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { disabilityOrAbsenceFromWork } from './disabilityOrAbsenceFromWork';

export const disabilityOrAbsence: AnswerPathTreeNode = {
  path: 'disabilityOrAbsence',
  children: [disabilityOrAbsenceFromWork],
};
